import ConfirmAssignmentModal from './confirm-assignment-modal.component'

export default ConfirmAssignmentModal